// extracted by mini-css-extract-plugin
export default {"table":"GatemasterPOSList_table__jTOwH","badge":"GatemasterPOSList_badge__7tHir","btn":"GatemasterPOSList_btn__74Xh0"};